import { Button, Switch, Typography } from 'antd';
import React, { useState } from 'react';
import Sheet from 'react-modal-sheet';
import { NotificationPrefs } from './mockData';
import styles from './styles.module.css';

type Props = {
  open: boolean;
  prefs: NotificationPrefs;
  onClose: () => void;
  onSave: (prefs: NotificationPrefs) => void;
};

const NotificationSheet: React.FC<Props> = ({ open, prefs, onClose, onSave }) => {
  const [local, setLocal] = useState<NotificationPrefs>(prefs);

  React.useEffect(() => setLocal(prefs), [prefs]);

  const toggleLeadDay = (d: number) => {
    setLocal((p) => ({
      ...p,
      leadDays: p.leadDays.includes(d)
        ? p.leadDays.filter((x) => x !== d)
        : [...p.leadDays, d].sort((a, b) => b - a),
    }));
  };

  const channels: Array<{
    key: keyof Pick<NotificationPrefs, 'whatsapp' | 'sms' | 'email' | 'push'>;
    icon: string;
    label: string;
    bg: string;
    fg: string;
  }> = [
    { key: 'whatsapp', icon: '💬', label: 'WhatsApp', bg: '#dcfce7', fg: '#16a34a' },
    { key: 'push', icon: '🔔', label: 'In-app Push', bg: '#e8f0ff', fg: '#0460ff' },
    { key: 'sms', icon: '📱', label: 'SMS', bg: '#fef3c7', fg: '#b45309' },
    { key: 'email', icon: '✉️', label: 'Email', bg: '#f3e8ff', fg: '#7c3aed' },
  ];

  return (
    <Sheet
      isOpen={open}
      onClose={onClose}
      detent='content-height'
      disableScrollLocking
      style={{ zIndex: 100, maxWidth: 480, margin: 'auto' }}
    >
      <Sheet.Container>
        <Sheet.Header />
        <Sheet.Content>
          <div className={styles.notifSheet}>
            <div>
              <div className={styles.addTitle}>Renewal reminders</div>
              <div className={styles.addSub}>
                We'll remind you before your insurance, PUC, road tax and
                FASTag run out.
              </div>
            </div>

            <div>
              <Typography.Text style={{ fontSize: 12, fontWeight: 600, color: '#6b7280' }}>
                CHANNELS
              </Typography.Text>
              {channels.map((c) => (
                <div key={c.key} className={styles.notifRow}>
                  <div className={styles.notifRowLabel}>
                    <span
                      className={styles.notifRowIcon}
                      style={{ background: c.bg, color: c.fg }}
                    >
                      {c.icon}
                    </span>
                    {c.label}
                  </div>
                  <Switch
                    checked={local[c.key]}
                    onChange={(v) => setLocal((p) => ({ ...p, [c.key]: v }))}
                  />
                </div>
              ))}
            </div>

            <div>
              <Typography.Text style={{ fontSize: 12, fontWeight: 600, color: '#6b7280' }}>
                REMIND ME BEFORE EXPIRY
              </Typography.Text>
              <div className={styles.leadDayChips}>
                {[30, 15, 7, 3, 1].map((d) => (
                  <span
                    key={d}
                    className={`${styles.leadDayChip} ${
                      local.leadDays.includes(d) ? styles.leadDayChipActive : ''
                    }`}
                    onClick={() => toggleLeadDay(d)}
                  >
                    {d} day{d > 1 ? 's' : ''}
                  </span>
                ))}
              </div>
            </div>

            <Button
              className={styles.addBtn}
              onClick={() => onSave(local)}
              style={{ width: '100%', height: 44 }}
            >
              Save preferences
            </Button>
          </div>
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop onTap={onClose} />
    </Sheet>
  );
};

export default NotificationSheet;
